import { Header, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

import NewChatButton from "@/components/layout/NewChatButton";
import MetadataConfiguration from "@/components/metadata-config/MetadataConfiguration";

const AdminMetadataConfigurationPage: React.FC = () => (
  <SpaceBetween size="xl">
    <Header
      variant="h1"
      description="Manage which Iconik metadata fields are available to the AI agent and visible in the clip preview panel."
      actions={<NewChatButton />}
    >
      Metadata Configuration
    </Header>
    <MetadataConfiguration />
  </SpaceBetween>
);

export default AdminMetadataConfigurationPage;
